import { MAX_COLUMNS } from "./data/constants";
import { getConfiguration } from "./data/utils";

const body = document.body;

//Observe the body for changes in its classes
const bodyElementObserver = new MutationObserver(function (event) {
    setAvailableSpaceForTables();
});

//*** GESTIONE DELLA LARGHEZZA DELLE TABELLE ***/
//*** GESTIONE DELLA LARGHEZZA DELLE TABELLE ***/
//*** GESTIONE DELLA LARGHEZZA DELLE TABELLE ***/
function getNumberOfSidebars() {
    let numberOfSidebars = 0;
    if (document.body.contains(document.getElementById("sidebar-sx"))) {
        numberOfSidebars += 1;
    }
    if (document.body.contains(document.getElementById("sidebar-dx"))) {
        numberOfSidebars += 1;
    }
    return numberOfSidebars;
}

function getNumberOfCollapsedSidebars() {
    let numberOfCollapsedSidebars = 0;
    if (body.classList.contains("e-largo")) {
        numberOfCollapsedSidebars += 1;
    }
    if (body.classList.contains("e-largo-dx")) {
        numberOfCollapsedSidebars += 1;
    }
    return numberOfCollapsedSidebars;
}

function getNumberOfExtraCentralColumns() {
    let numberOfExtraCentralColumns = 0
    if (!body.classList.contains("e-largo-centro")) {
        numberOfExtraCentralColumns += 1
        try {
            if (window.getComputedStyle(document.getElementsByClassName("secondo-blocco-sport")[0]).display === "none") {
                numberOfExtraCentralColumns -= 1
            }
        } catch(err) {

        }
    }

    return numberOfExtraCentralColumns;
}

function checkAvailableSpaceForTables() {
    let availableSpace = 4;
    let numberOfSidebars = getNumberOfSidebars();
    let numberOfCollapsedSidebars = getNumberOfCollapsedSidebars();
    let numberOfExtraCentralColumns = getNumberOfExtraCentralColumns();

    availableSpace = availableSpace - numberOfSidebars + numberOfCollapsedSidebars - numberOfExtraCentralColumns;

    return [availableSpace, numberOfExtraCentralColumns];
}

function setTablesExpandedOrCollapsedClass() {
  let availableSpaceForTables = checkAvailableSpaceForTables()[0];
  const container = document.getElementById("primo-blocco-sport");
  const conf = getConfiguration();

    if(conf.iwh){
      if (window.matchMedia("(min-width: 2000px)").matches) {
        switch (availableSpaceForTables) {
          case 1:
          case 2:
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            break;
        }
        return;
      }
     
 
      if (window.matchMedia(`(min-width: 1750px)`).matches) {
        switch (availableSpaceForTables) {
          
          case 1:
          case 2:
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      }

      if (window.matchMedia(`(min-width: 1560px)`).matches) {
        switch (availableSpaceForTables) {
          
          case 1:

            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
          case 2:
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      }
  
  
  
  
      if (window.matchMedia(`(min-width: 1460px)`).matches) {
        switch (availableSpaceForTables) {
          
          case 1:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
          case 2:
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      }

        
      if (window.matchMedia(`(min-width: 1200px)`).matches) {
        switch (availableSpaceForTables) {
          case 1:
          case 2:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      }
  
      
  
      if (conf?.coc !== MAX_COLUMNS && window.matchMedia("(min-width: 1200px)").matches) {
        switch (availableSpaceForTables) {
          case 1:
          case 2:
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      } else if (window.matchMedia("(min-width: 1200px)").matches) {
        switch (availableSpaceForTables) {
          case 1:
          case 2:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
          case 3:
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
        return;
      }
  
      if (window.matchMedia("(min-width: 1px)").matches) {
        switch (availableSpaceForTables) {
          case 1:
          case 2:
          case 3:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
          case 4:
            if (container) {
              container.classList.remove("tablesCompacted");
              container.classList.add("tablesExpanded");
            }
            break;
          default:
            if (container) {
              container.classList.add("tablesCompacted");
              container.classList.remove("tablesExpanded");
            }
            break;
        }
      }
    } else {

    if (window.matchMedia("(min-width: 2000px)").matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
        case 3:
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          break;
      }
      return;
    }
   

    if (window.matchMedia(`(min-width: 1440px)`).matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
        case 3:
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
      }
      return;
    }



    if (window.matchMedia(`(min-width: 1360px)`).matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
        case 3:
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
      }
      return;
    }

    

    if (conf?.coc !== MAX_COLUMNS && window.matchMedia("(min-width: 1200px)").matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
        case 3:
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
      }
      return;
    } else if (window.matchMedia("(min-width: 1200px)").matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
        case 3:
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
      }
      return;
    }

    if (window.matchMedia("(min-width: 1px)").matches) {
      switch (availableSpaceForTables) {
        case 1:
        case 2:
        case 3:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
        case 4:
          if (container) {
            container.classList.remove("tablesCompacted");
            container.classList.add("tablesExpanded");
          }
          break;
        default:
          if (container) {
            container.classList.add("tablesCompacted");
            container.classList.remove("tablesExpanded");
          }
          break;
      }
    }
  }
    return;
}

export function setAvailableSpaceForTables() {
    bodyElementObserver.disconnect();
    const [ats, dcs] = checkAvailableSpaceForTables();
    body.setAttribute("data-available-table-space", ats);
    body.setAttribute("data-extra-central-columns", dcs);
    setTablesExpandedOrCollapsedClass();

    bodyElementObserver.observe(body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
    });
}

export function checkForDashClass(tabellaQuote) {
   if (body.classList.contains("tablesExpanded")) {
       if (tabellaQuote.childElementCount !== 0) {
           let first_P_Child = tabellaQuote.getElementsByTagName("p")[0]
           let last_P_Child = tabellaQuote.getElementsByTagName("p")[tabellaQuote.getElementsByTagName("p").length - 1]

           let first_P_ChildOffsetTop = first_P_Child.offsetTop
           let last_P_ChildOffsetTop = last_P_Child.offsetTop

           /* Different rows */
           if (first_P_ChildOffsetTop !== last_P_ChildOffsetTop) {
               first_P_Child.classList.remove("dash-after-class")
               first_P_Child.classList.remove("dash-after-transparent-class")

               first_P_ChildOffsetTop = first_P_Child.offsetTop
               last_P_ChildOffsetTop = tabellaQuote.lastElementChild.offsetTop

               /* Check if after removing a dash they are still on two different rows*/
               if (first_P_ChildOffsetTop === last_P_ChildOffsetTop) {
                   first_P_Child.classList.add("dash-after-transparent-class")
               }
           }
           /* Same Row */
           else {
               first_P_Child.classList.remove("dash-after-transparent-class")
               first_P_Child.classList.add("dash-after-class")

               first_P_ChildOffsetTop = first_P_Child.offsetTop
               last_P_ChildOffsetTop = tabellaQuote.lastElementChild.offsetTop

               /* Check if after adding a dash they are still on the same row */
               if (first_P_ChildOffsetTop !== last_P_ChildOffsetTop) {

                   first_P_Child.classList.remove("dash-after-class")
                   first_P_Child.classList.add("dash-after-transparent-class")
               }
           }
       }
   } else if (tabellaQuote.childElementCount !== 0) {
       let first_P_Child = tabellaQuote.getElementsByTagName("p")[0]
       first_P_Child.classList.remove("dash-after-class")
       first_P_Child.classList.remove("dash-after-transparent-class")
   }
}

export function initTables() {
    window.addEventListener("resize", setAvailableSpaceForTables)
    
    bodyElementObserver.observe(body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
    });

    setAvailableSpaceForTables();
}

export function adjustOddsAlignment() {
    document.querySelectorAll('.tabellaQuoteIntestazione').forEach(row => {
        let [numQuote, numGruppi] = [0, 0];

        numQuote += row.getElementsByClassName("tabellaQuoteIntestazione-QuotaSingola").length;
        numQuote += row.getElementsByClassName("dropdown-toggle").length;
        numGruppi += row.getElementsByClassName("tabellaQuoteIntestazione-GruppoQuote").length;
        
        row.setAttribute("data-numero-quote", numQuote);
        row.setAttribute("data-numero-gruppi-quote", numGruppi);
    });
    document.querySelectorAll('.tabellaQuoteNew').forEach(row => {
        let [numQuote, numGruppi] = [0, 0];
        
        /* *:not(.lista-quote) is needed to ignore odds that are inside a U/O box selector */
        numQuote += row.querySelectorAll('*:not(.lista-quote) > .contenitoreSingolaQuota').length;
        numQuote += row.getElementsByClassName("dropdown-toggle").length;
        numGruppi += row.getElementsByClassName("contenitoreSetQuotazioni").length;
        
        row.setAttribute("data-numero-quote", numQuote);
        row.setAttribute("data-numero-gruppi-quote", numGruppi);

    });
}
